import {
    getOrdersOfOrderTypeFilter,
    persistOrdersOfOrderTypeFilter,
} from '../../../constants/state';

export const SET_ORDER_TYPE_FILTER = 'SET_ORDER_TYPE_FILTER';

export const setOrderTypeFilter = (vitalsType, filter) => {
    const ordersOfOrderType = getOrdersOfOrderTypeFilter() || {};
    const safeFilter = filter || {};
    const minimalFilter = {
        datePeriod: safeFilter.datePeriod || null,
        doctor: safeFilter.doctor || null,
        excludedDoctor: safeFilter.excludedDoctor || null,
    };
    ordersOfOrderType[vitalsType] = JSON.stringify(minimalFilter);
    persistOrdersOfOrderTypeFilter(ordersOfOrderType);
    return {
        type: SET_ORDER_TYPE_FILTER,
        payload: { vitalsType, filter },
    };
};
